import { render } from "./ScratchCard.vue?vue&type=template&id=30716cd2&scoped=true"
import script from "./ScratchCard.vue?vue&type=script&lang=js"
export * from "./ScratchCard.vue?vue&type=script&lang=js"

import "./ScratchCard.vue?vue&type=style&index=0&id=30716cd2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30716cd2"]])

export default __exports__